export const persistedInventoryUpdatesRef = { current: {} };

export const clearPersistedInventoryUpdates = () => {
  persistedInventoryUpdatesRef.current = {};
};
